import { useCallback } from 'react';
import { isEmpty } from 'lodash';
import { Typography, Stack } from '@mui/material';
import { useDispatch, useListeners, useSelector } from '@client/hooks/redux.hooks';
import { FormStack, TextField } from '@client/components/forms';
import { GoogleSearch } from '@client/components/forms/GoogleSearch';
import { startCreatePartialAct } from '@client/slices/entities/acts.reducer';
import { getSelectedProfile } from '@client/selectors/helpers/profile';
import { ProfileTypes } from '@sda/enums';
import { SignupWrapperForm } from '../../common/SignupWrapper/SignupWrapperForm';
import { SignupArtistCreateSchema } from './signup-artist-create.schema';
import { signupArtistCreateListeners, startSaveArtistBasics } from './signup-artist-create.listeners';

const Explainer = (
  <Stack spacing={3}>
    <Typography
      align="left"
      variant="h6"
    >
      Profile basics
    </Typography>

    <Typography
      color="textSecondary"
      align="left"
    >
      Let hosts know the name of your project and where you're based.
    </Typography>
  </Stack>
);

export const Create = () => {
  const dispatch = useDispatch();
  const selectedProfile = useSelector(getSelectedProfile);

  useListeners(signupArtistCreateListeners);

  const initialValues = {
    compiledAddress: selectedProfile?.profileType === ProfileTypes.ACT ? selectedProfile.compiledAddress : '',
    latLng: selectedProfile?.profileType === ProfileTypes.ACT ? selectedProfile.latLng : null,
    googlePlaceId: selectedProfile?.profileType === ProfileTypes.ACT ? selectedProfile.googlePlaceId : '',
    name: selectedProfile?.profileType === ProfileTypes.ACT ? selectedProfile.name : '',
  };

  const handleSubmit = useCallback((values: typeof initialValues) => {
    if (selectedProfile?.profileType === ProfileTypes.ACT) {
      dispatch(startSaveArtistBasics(values));
    } else {
      dispatch(startCreatePartialAct(values));
    }
  }, [dispatch, selectedProfile]);

  return (
    <SignupWrapperForm
      steps={6}
      currentStep={1}
      renderExplainer={Explainer}
      FormikProps={{
        initialValues,
        onSubmit: handleSubmit,
        validationSchema: SignupArtistCreateSchema,
      }}
      buttonProps={({ values }) => ({
        scope: 'signup-act-create-form',
        ButtonProps: {
          disabled: isEmpty(values.googlePlaceId) || isEmpty(values.name),
        },
      })}
    >
      <FormStack>
        <TextField
          name="name"
          label="Profile name"
          maxLength={50}
          fullWidth
          required
        />

        <GoogleSearch
          name="compiledAddress"
          label="City"
          type="(cities)"
          fullWidth
          includeLatLngField
          required
        />
      </FormStack>
    </SignupWrapperForm>
  );
};
